import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M181.341 239.36c98.987 127.147 245.334 315.307 245.334 315.307v213.333c0 46.933 38.4 85.333 85.333 85.333s85.333-38.4 85.333-85.333v-213.333c0 0 146.347-188.16 245.333-315.307 21.76-28.16 1.707-68.693-34.133-68.693h-593.494c-35.413 0-55.467 40.533-33.707 68.693z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgFilter);
export default ForwardRef;
